import { PageController } from '@client/components/_core/layout/PageController';
import { ControlTestEdit } from '@client/components/controls/control-test-edit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/controls/register/details/$id/test/add')({
    staticData: {
        presentation: 'overlay',
        ui: { useParentTitle: true },
    },
    component: ControlTestAddRoute,
});

function ControlTestAddRoute() {
    const { id: controlId } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { trpcUtils } = useTrpc();

    return (
        <PageController route={Route}>
            <ControlTestEdit
                action={['add', controlId]}
                onClose={async () => {
                    await trpcUtils.control.test.invalidate();
                    navigate({
                        to: '/console/$orgId/controls/register/details/$id',
                        params: { orgId, id: controlId },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
